import * as React from "react";
import {faFilePdf, faImage} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}    from "@fortawesome/react-fontawesome";

import "./upload-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {scn}            from "@Common/react/state-change-nested-value";
import {Static2}        from "@Common/react/static-2";
import {UseState}       from "@Common/react/use-state";
import {ModalService3}  from "@Common/ui-components/modal-service-3/modal-service-3";

import {ModalLayout}     from "../../../../common/modal-layout/modal-layout";
import {ClearableSelect} from "../../image-asset-edit-modal/clearable-select/clearable-select";

export const UploadModal = ({
    title,
    onUpload,
    allowDefaultOption,
    placeholder,
    next: rootNext,
}: {
    title: string,
    allowDefaultOption: boolean|number,
    placeholder: string,
    next: () => any,
    onUpload: (data) => any,
}) => cs(

    ["modal", ({}, next) => ModalService3({
        xdQaName: "Upload Card Modal",
        width: 600,
        next,
        rootNext,
    })],
    consumeContext("apis"),
    ["uploading", (_, next) => UseState({next})],
    ["ref", (_, next) => Static2({next})],
    ["state", (_, next) => UseState({next, initValue: {name: null, file: null}})],
    ["hasInvalidFormat", ({state}, next) => next(state.value.file && !["image/jpeg", "image/png", "application/pdf"].includes(state.value.file.type))],
    ({uploading, state, apis, modal, hasInvalidFormat}, next) => ModalLayout({
        title: `Upload New ${title}`,
        content: next(),
        buttons: [
            {
                label: "Cancel",
                onClick: () => {
                    modal.close();
                },
            },
            {
                label: "Upload",
                disabled: !state.value.file || !state.value.name || hasInvalidFormat || uploading.value,
                primary: true,
                onClick: async () => {
                    uploading.onChange(true);
                    const success = await onUpload(state.value);
                    uploading.onChange(false);
                    if (success) {
                        modal.close();
                    }
                },
            },
        ],
    }),
    ({state, hasInvalidFormat, ref}) => (
        <div className="upload-modal-nn2">
            <div className="top">
                <div className="card">
                    <div className="img-container">
                        {state.value.url && state.value.file?.type !== "application/pdf" && !hasInvalidFormat ? (
                            <img
                                className="uploaded"
                                src={state.value.url}
                                alt={state.value.file?.name}
                                xd-qa-type="image"
                                xd-qa-name="headshot"
                            />
                        ) : (
                            <div className={state.value.file?.type === "application/pdf" ? "pdf" : "no-img"}>
                                {<FontAwesomeIcon
                                    className="img-icon"
                                    icon={state.value.file?.type === "application/pdf" ? faFilePdf : faImage}
                                    xd-qa-type="icon"
                                    xd-qa-name="image"
                                />}
                            </div>
                        )}
                    </div>
                    <div className="right">
                        <div className="input">
                            <input
                                className="hidden-input"
                                type="file"
                                xd-qa-name="Select a File"
                                xd-qa-type="file_input"
                                ref={ref.set}
                                onChange={(e) => {
                                    const val = e.target?.files?.[0];
                                    val && scn(state, ["file"], _ => val);
                                    val && scn(state, ["url"], _ => URL.createObjectURL(val));
                                }}
                            />
                            <button
                                className="select-file"
                                onClick={() => ref.get().click()}
                            >
                                Select a File
                            </button>
                        </div>
                        <div className="types" xd-qa-type="label" xd-qa-name="types">
                            {state.value.file?.name ?? "jpeg, png, or pdf"}
                        </div>
                        {hasInvalidFormat && (
                            <div className="error" xd-qa-type="label" xd-qa-name="Error">
                                You are attempting to upload an image of a type we do not support. Please select a JPEG/PNG or PDF file to upload.
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="bottom">
                <div {...{
                    className: "text",

                    "xd-qa-type": "label",
                    "xd-qa-name": "Name your Photo",
                }}>
                    Name your Photo
                </div>
                <input
                    className="name"
                    xd-qa-name="Name Your Photo"
                    xd-qa-type="text_field"
                    placeholder={placeholder}
                    onChange={(e) => {
                        const val = e.target.value;
                        scn(state, ["name"], _ => val);
                    }}
                >
                </input>
                {allowDefaultOption && (
                    <div className="default-dropdown">
                        {ClearableSelect({
                            list: allowDefaultOption === 1 ? [1] : [1, 2],
                            placeholder: "Make Default",
                            isSelected: v => v === state.value.defaultSlot,
                            xdQaName: "Make Default",
                            onSelect: index => scn(state, ["defaultSlot"], _ => index),
                            onClear: () => scn(state, ["defaultSlot"], _ => 0),
                            getToggleLabel: i => "Default " + title.replace("Default ", "") + " #" + i,
                            getExpandLabel: i => title + " #" + i,
                        })}
                    </div>
                )}
            </div>
        </div>
    )
);

